import React from "react";
import AntexUI from "./components/AntexUI";
import Banner from "./components/Banner";
import NFT from "./components/NFT";
import Project from "./components/Project";

const Home = () => {
	return (
		<>
			<Banner />
			<AntexUI />
			<Project />
			<NFT />
		</>
	);
};

export default Home;
